import type { AccessConstraint } from '@sb/shared/access';

/** Access constraints for the account container and its parent-gated children (billing, integrations). */
export const accountAccess = {
  root: { permission: ['Manage account', 'Manage API tokens', 'Manage payroll apps', 'Manage non payroll apps'] },
  billing: { permission: ['Manage account'] },
  integrations: { permission: ['Manage API tokens', 'Manage payroll apps', 'Manage non payroll apps'] },
} satisfies Record<string, AccessConstraint>;
